export default __webpack_public_path__ + "static/assets/med_pill_square_out_L2_solid_x_01_f.7715cce9.png";